<template>
  <div>    
    <b-card>
      <b-row class="mb-1" align-v="center">
        <b-col md="4">
          
          <b-form-group
            label="Name"
            label-for="name"
          >
            <b-input-group>
              <template #prepend> </template>
            </b-input-group>
            <b-form-input id="name" v-model="name" placeholder="Name" />
          </b-form-group>
        </b-col>
        <b-col md="4">

          <b-form-group
            label="Building"
            label-for="building"
          >
            <v-select
              label="name"
              v-model="building"
              placeholder="Select Building"
              :options="buildings"
              autoscroll
              :clearable="true"
            ></v-select>
          </b-form-group>
        </b-col>
        <b-col md="4">  
          <b-form-group
            label="Mobile Number"
            label-for="mobile_number"
          >
            <b-form-input id="mobile_number" type="text" v-model="mobile_number" placeholder="Mobile Number" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="PEEP Status"
            label-for="peep_status"
          >
            <v-select
              label="name"
              v-model="is_peep"
              placeholder="Select PEEP Status"
              :options="[{value: true, name: 'Yes'},{value: false, name: 'No'}]"
              autoscroll
              :clearable="true"
            ></v-select>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="In Building"
            label-for="in_building"
          >
            <v-select
              label="name"
              v-model="in_building"
              placeholder="Select In Building Status"
              :options="[{value: true, name: 'Yes'},{value: false, name: 'No'},{value: null, name: 'Pending'} ]"
              autoscroll
              :clearable="true"
            ></v-select>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="Reached Assembly Area"
            label-for="reached_assembly_area"
          >
            <v-select
              label="name"
              v-model="reached_assembly_area"
              placeholder="Select In Reached Assembly Area"
              :options="[{value: true, name: 'Yes'},{value: null, name: 'Pending'} ]"
              autoscroll
              :clearable="true"
            ></v-select>
          </b-form-group>
        </b-col>
        
        <b-col md="12" class="text-right">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>&nbsp;
          <b-button variant="secondary" pill @click="resetSearch">
            <span class="align-middle">Reset</span>
          </b-button>&nbsp;
          <b-button variant="success" pill @click="exportToCSV">
            <feather-icon icon="DownloadIcon" class="mr-50" />
            <span class="align-middle">Export CSV</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="building_emergency_data"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_user')"
        :per-page="0"
        :tbody-tr-class="rowClass"
      > 
        <template #cell(name)="row">          
          <b-link style="padding-right: 15px; color: black;" @click="row.toggleDetails" v-if="row.item.user_data.is_peep">
            <feather-icon  icon="PlusSquareIcon" /> 
          </b-link>
            {{
              row.item.user_data ? row.item.user_data.name : ""
            }}          
        </template>

        <template #cell(phone_number)="row">
            {{
              row.item.user_data ? row.item.user_data.mobile_number : ""
            }}
        </template>


        <template #cell(building_data)="row">
            {{
              row.item.building_data ? row.item.building_data.name : ""
            }}
        </template>

        <template #cell(is_peep)="row">
            {{
              row.item.user_data.is_peep ? 'Yes' : 'No'
            }}
        </template>

        <template #cell(is_active)="row">
            {{
              row.item.is_active === true ? 'Yes' : 'No'
            }}
        </template>


        <template #cell(in_building)="row">
            {{
              row.item.in_building ? 'Yes' : 'No'
            }}
        </template>

        <template #cell(exit_building)="row">
            {{
              row.item.exit_building ? 'Yes' : 'No'
            }}
        </template>

        <template #cell(reached_assembly_area)="row">
            {{
              row.item.reached_assembly_area ? 'Yes' : 'No'
            }}
        </template>

        <template #row-details="row">
          <b-card bg-variant="light" border-variant="dark">
            <b-table
              responsive="sm"
              :fields="user_flats_fields"
              :items="row.item.nominee_data"
              details-td-class="m-0 p-0"
              small
            >
            </b-table>
          </b-card>
        </template>

        <template #cell(role_data)="row">
          {{ row.item.role_data ? row.item.role_data.name : "" }}
        </template>        
        <template #cell(profile_status)="row">
          <b-badge :variant="badgeVariant(row.item.profile_status)">
            {{ row.item.profile_status }}
          </b-badge>
        </template>
        <template #cell(has_pending_flats)="row">
          {{ row.item.has_pending_flats ? 'Yes' : 'No' }}
        </template>  
      </b-table>
      <div class="row">
        <div class="col-md-11">
          <b-pagination
            size="md"
            :total-rows="totalItems"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div class="col-md-1">
          <h4>
          Total: {{ totalItems }} 
          </h4>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Name" },
        { key: "phone_number", label: "Contact Number" },
        { key: "building_data", label: "Building" },
        { key: "is_peep", label: "PEEP Status" },
        { key: "is_active", label: "Response on Alert" },
        { key: "in_building", label: "In Building" },
        { key: "exit_building", label: "Exited From Building" },
        { key: "reached_assembly_area", label: "Reached Assembly Area" },
        { key: "updated_at", label: "Last Update At" },
      ],
      user_flats_fields: [
        { key: "nominee_name", label: "Nominee Name" },
        { key: "nominee_contact", label: "Nominee Contact" },
        { key: "assistance_type", label: "Assistance Type" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      building_emergency_data: [],
      building_emergency_data_list: [],
      searchTypes: [
        { value: 1, name: "Name" },
        { value: 2, name: "Building" },
        { value: 3, name: "Mobile Number" },
        { value: 4, name: "Peep Status" },
        { value: 5, name: "In Building" },
        { value: 6, name: "Reached Assembly Area" },
      ],
      searchType: null,
      buildings: [],
      name : "",
      building : "",
      mobile_number : "",
      is_peep : "",
      in_building : "",
      reached_assembly_area : "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
    await this.fetchUnPaginatedData();
    const sites = await this.getSitesDDL();
    this.sites = sites.data;

    const buildings = await this.getBuildingsDDL();
    this.buildings = buildings.data;

    const floors = await this.getFloorsDDL();
    this.floors = floors.data;
  },
  methods: {
    ...mapActions({
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getFloorsDDL: "appData/getFloorsDDL",
      getBuildingEmergencyState: "appData/getBuildingEmergencyState",
      getFlatUsers: "appData/getFlatUsers",
      getFlatUsersList: "appData/getFlatUsersList",
    }),
    async search() {
      // if (this.searchType) {
      //   switch (this.searchType.value) {
      //     case 1:
      //       this.building = "";
      //       this.mobile_number = "";
      //       this.is_peep = "";
      //       this.in_building = "";
      //       this.reached_assembly_area = "";
      //       break;
      //     case 2:
      //       this.name = "";
      //       this.mobile_number = "";
      //       this.is_peep = "";
      //       this.in_building = "";
      //       this.reached_assembly_area = "";
      //       break;
      //     case 3:
      //       this.name = "";
      //       this.building = "";
      //       this.is_peep = "";
      //       this.in_building = "";
      //       this.reached_assembly_area = "";
      //       break;
      //     case 4:
      //       this.name = "";
      //       this.building = "";
      //       this.mobile_number = "";
      //       this.in_building = "";
      //       this.reached_assembly_area = "";
      //       break;
      //     case 5:
      //       this.name = "";
      //       this.building = "";
      //       this.mobile_number = "";
      //       this.is_peep = "";
      //       this.reached_assembly_area = "";
      //       break;
      //     case 6:
      //       this.name = "";
      //       this.building = "";
      //       this.mobile_number = "";
      //       this.is_peep = "";
      //       this.in_building = "";
      //       break;
      //             }
      // } else {
      //   this.name = "";
      //   this.building = "";
      //   this.mobile_number = "";
      //   this.is_peep = "";
      //   this.in_building = "";
      //   this.reached_assembly_area = "";
      // }
      this.currentPage = 1;
      await this.fetchPaginatedData();
      await this.fetchUnPaginatedData();
    },
    resetSearch(){
        this.name = "";
        this.building = "";
        this.mobile_number = "";
        this.is_peep = "";
        this.in_building = "";
        this.reached_assembly_area = "";
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getFlatUsers({
          pageNumber: this.currentPage,
          name : this.name,
          building : this.building.id,
          mobile_number : this.mobile_number,
          is_peep : this.is_peep.value,
          in_building : this.in_building.value,
          reached_assembly_area : this.reached_assembly_area.value,
        });
        this.building_emergency_data = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },

    async fetchUnPaginatedData() {
      try {
        const res = await this.getFlatUsersList({
          pageNumber: this.currentPage,
          name : this.name,
          building : this.building.id,
          mobile_number : this.mobile_number,
          is_peep : this.is_peep.value,
          in_building : this.in_building.value,
          reached_assembly_area : this.reached_assembly_area.value,
        });
        this.building_emergency_data_list = res.data;
      } catch (error) {
        this.displayError(error);
      }
    },

    badgeVariant(status) {
      switch (status) {
        case 'Approved':
          return 'success';
        case 'Rejected':
          return 'danger';
        case 'Pending':
          return 'warning';
        case 'Left':
          return 'dark';
        default:
          return 'light';
      }
    },
    badgeVariantUserFlats(status) {
      switch (status) {
        case true:
          return 'success';
        case false:
          return 'danger';
        case null:
          return 'warning';
        
        default:
          return 'light';
      }
    },
    
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.in_building === true  && (item.exit_building === false || item.exit_building === null) && (item.reached_assembly_area === false || item.reached_assembly_area === null)) return 'table-danger'
      if (item.in_building === true  && item.exit_building === true && (item.reached_assembly_area === false || item.reached_assembly_area === null)) return 'table-primary'
      if (item.in_building === true && item.reached_assembly_area === true) return 'table-success'
    },

    exportToCSV() {
      const headers = [
        'Name',
        'Contact Number',
        'Building',
        'PEEP Status',
        'Response on Alert',
        'In Building',
        'Exited From Building',
        'Reached Assembly Area',
        'Last Update At'
      ].join(',')
      
      const rows = this.building_emergency_data_list.map(item => {
        return [
          `"${item.user_data ? item.user_data.name : ''}"`,
          `"${item.user_data ? item.user_data.mobile_number : ''}"`,
          `"${item.building_data ? item.building_data.name : ''}"`,
          `"${item.user_data.is_peep ? 'Yes' : 'No'}"`,
          `"${item.is_active ? 'Yes' : 'No'}"`,
          `"${item.in_building ? 'Yes' : 'No'}"`,
          `"${item.exit_building ? 'Yes' : 'No'}"`,
          `"${item.reached_assembly_area ? 'Yes' : 'No'}"`,
          `"${item.updated_at}"`
        ].join(',')
      }).join('\n')
      
      const csvContent = `${headers}\n${rows}`
      
      // Create download link
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      
      link.setAttribute('href', url)
      link.setAttribute('download', 'emergency_status_report.csv')
      link.style.visibility = 'hidden'
      
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  computed: {
    ...mapGetters({ hasPermission: "appData/hasPermission", getLoggedInUser: "appData/getLoggedInUser" },
    ),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
      await this.fetchUnPaginatedData();
    },
  },
};
</script>

<style scoped>
.amber-background {
  background-color: #ffbf00 !important;
}
</style>

